export default __webpack_public_path__ + "static/media/hero1.8f5883ea.png";